import API, { graphqlOperation } from '@aws-amplify/api'
import loader from './loader'

/**
 * Available action types
 */
export const ACTION = {
  GET_COMPANY_NOTIFICATION_EMAIL: 'get-company-notification-email',
  UPDATE_COMPANY_NOTIFICATION_EMAIL: 'update-company-notification-email',
  GET_COMPANY_HYDROPONICS_SETTINGS: 'get-company-hydroponics-settings',
  UPDATE_COMPANY_HYDROPONICS_SETTINGS: 'update-company-hydroponics-settings',
  INSERT_COMPANY: 'insert-company'
}

/**
 * Loading keys
 */
export const LOAD = ACTION

export const getCompanyNotificationEmailQuery = `
  query {
    getCompanyNotificationEmail {
      emailAddress
      active
      interval
      anomalies
      hydroponics
    }
  }
`

export const updateCompanyNotificationEmailQuery = `
  mutation ($emailAddress: String!, $active: Boolean!, $interval: String, $anomalies: Boolean, $hydroponics: Boolean) {
    updateCompanyNotificationEmail (emailAddress: $emailAddress, active: $active, interval: $interval, anomalies: $anomalies, hydroponics: $hydroponics) {
      emailAddress
      active
      interval
      anomalies
      hydroponics
    }
  }
`

export const insertCompanyQuery = `
  mutation ($name: String!, $parentCompanyId: Int!, $companyType: Int!) {
    insertCompany (name: $name, parentCompanyId: $parentCompanyId, companyType: $companyType) 
  }
`

export const getCompanyHydroponicsSettingsQuery = `
  query {
    getCompanyHydroponicsSettings {
      inArea
      outArea
      potQuantity
    }
  }
`

export const updateCompanyHydroponicsSettingsQuery = `
  mutation ($inArea: Int, $outArea: Int, $potQuantity: Int!) {
    updateCompanyHydroponicsSettings (inArea: $inArea, outArea: $outArea, potQuantity: $potQuantity) {
      inArea
      outArea
      potQuantity
    }
  }
`


export const getCompanyNotificationEmail = () => {
  return loader.load(LOAD.GET_COMPANY_NOTIFICATION_EMAIL, (dispatch) => {
    return API.graphql(graphqlOperation(getCompanyNotificationEmailQuery))
      .then((result) => dispatch({ type: ACTION.GET_COMPANY_NOTIFICATION_EMAIL, data: result.data.getCompanyNotificationEmail }))
  })
}

export const updateCompanyNotificationEmail = (email, active, interval, anomalies, hydroponics) => {
  return loader.load(LOAD.UPDATE_COMPANY_NOTIFICATION_EMAIL, (dispatch) => {
    return API.graphql(graphqlOperation(updateCompanyNotificationEmailQuery, { emailAddress: email, active, interval, anomalies, hydroponics }))
      .then((result) => dispatch({ type: ACTION.UPDATE_COMPANY_NOTIFICATION_EMAIL, data: result.data.updateCompanyNotificationEmail }))
  })
}

export const insertCompany = (name,parentCompanyId,companyType) => {
  return loader.load(LOAD.INSERT_COMPANY, (dispatch) => {
    return API.graphql(graphqlOperation(insertCompanyQuery, { name,parentCompanyId,companyType }))
      .then((result) => dispatch({ type: ACTION.INSERT_COMPANY, data: result.data }))
  })
}

export const getCompanyHydroponicsSettings = () => {
  return loader.load(LOAD.GET_COMPANY_HYDROPONICS_SETTINGS, (dispatch) => {
    return API.graphql(graphqlOperation(getCompanyHydroponicsSettingsQuery))
      .then((result) => dispatch({ type: ACTION.GET_COMPANY_HYDROPONICS_SETTINGS, data: result.data.getCompanyHydroponicsSettings }))
  })
}

export const updateCompanyHydroponicsSettings = (inArea, outArea, potQuantity) => {
  return loader.load(LOAD.UPDATE_COMPANY_HYDROPONICS_SETTINGS, (dispatch) => {
    return API.graphql(graphqlOperation(updateCompanyHydroponicsSettingsQuery, { inArea: inArea || null, outArea: outArea || null, potQuantity }))
      .then((result) => dispatch({ type: ACTION.UPDATE_COMPANY_HYDROPONICS_SETTINGS, data: result.data.updateCompanyHydroponicsSettings }))
  })
}

const initial = {
  notification: null
}

export const reducer = (state = initial, action) => {
  switch (action.type) {
    case ACTION.GET_COMPANY_NOTIFICATION_EMAIL:
      return {
        ...state,
        notification: action.data
      }
    case ACTION.UPDATE_COMPANY_NOTIFICATION_EMAIL:
      return {
        ...state,
        notification: action.data
      }
    case ACTION.INSERT_COMPANY:
      return {
        ...state,
        insertCompany: action.data
      }
    case ACTION.GET_COMPANY_HYDROPONICS_SETTINGS:
    case ACTION.UPDATE_COMPANY_HYDROPONICS_SETTINGS:
      return {
        ...state,
        hydroponicsSettings: action.data
      }
    default:
      return state
  }
}

